import { MarketingProvider } from 'API';
import { BusinessMetadata } from 'custom-types';
import Head from 'next/head';
import { FC, useEffect } from 'react';
import { getLogger } from 'utils';

interface MarketingConnectionProps {
  marketing: BusinessMetadata['marketing'];
}

export const MarketingConnection: FC<MarketingConnectionProps> = ({ marketing }) => {
  const log = getLogger('MarketingConnection');
  const { integrationScript, provider } = marketing ?? {};

  const badScript = integrationScript && integrationScript.startsWith('<script');
  useEffect(() => {
    if (badScript) {
      log.error(`misconfigured integrationScript (remove the script tags)`);
    }
  }, [badScript]);

  if (!integrationScript || badScript) {
    return null;
  }

  // Mailchimp is finnicky. You have to embed the entire script into your webpage exactly like this, otherwise it fails
  // validation.
  if (provider === MarketingProvider.MAILCHIMP) {
    return (
      <Head>
        <script id="mcjs" dangerouslySetInnerHTML={{ __html: integrationScript }} />
      </Head>
    );
  }

  // Klaviyo (and probably other providers) will just let you load from their CDN.
  return (
    <Head>
      <script type="text/javascript" async src={integrationScript} />
    </Head>
  );
};
